import './userSettings.scss';

import React from 'react';
import { Translate } from 'react-localize-redux';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import ExternalWebIcon from '../../img/icons/SkyMinderAirating';
import { bindActionCreators } from 'redux';
import { userContextActions } from '../../store/userContextStore';
import { layoutActions } from '../../store/layoutStore';
import { lastSubjectActions } from '../../store/lastSubjectsStore';
import { hasPermission } from '../../store/apiWrapper';
import { newsActions } from '../../store/newsStore';
import { popupActions } from "../../store/popupStore";
import LanguageSelector from '../common/languageSelector'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class UserSettings extends React.Component {
    render() {
        return (<>
            <a className='navbar-item' onClick={() => this.props.changePwd()}>
                {this.createNavbarRow("DashboardLayout.ChangePassword", "key")}
            </a>
            {hasPermission(null, 'PanelUser') && !hasPermission(null, 'PanelUserDENYDetail') && <>
                <hr className="navbar-divider"></hr>
                <Link to='/user' className='navbar-item'>
                    {this.createNavbarRow("DashboardLayout.AccountDetails", "street-view")}
                </Link>
            </>}

            <hr className="navbar-divider"></hr>
            <a className='navbar-item' onClick={() => this.props.toggleSettingsMenu()}>
                {this.createNavbarRow("Settings.Display.Heading", "desktop")}
            </a>
            {hasPermission(null, 'TokenGeneratorForm') && <>
                <hr className="navbar-divider"></hr>
                <Link to='/hyperlink/generate-token' target="_blank" className='navbar-item'>
                    {this.createNavbarRow("Hyperlink.Generate.Token", "link")}
                </Link>
            </>}
            <hr className="navbar-divider desktop-hidden"></hr>
            <a className='navbar-item desktop-hidden' onClick={() => { this.openPopup() }}>
                <Translate id="Feedback" />
            </a>
            <hr className="navbar-divider"></hr>
            <div className='navbar-item'>
                <div className='columns'>
                    <div className='column is-11 is-offset-1'>
                        <div><Translate id='User.Languange' /></div>
                        <div style={{ width: "100%" }}><LanguageSelector centerFlags={true} /></div>
                    </div>
                </div>
            </div>
            <hr className="navbar-divider" style={{ marginBottom: "0" }}></hr>
            <a className='navbar-item sign-out' onClick={() => { this.props.resetSubjects(); this.props.logoutNotifications(); this.props.logout() }}>
                {this.createNavbarRow("DashboardLayout.SignOut", "sign-out-alt")}
            </a>
        </>)
    }

    openPopup = () => {
        this.props.showPopup("feedbackPopup",
            {
                open: true,
                style: { maxHeight: '100%' },
                ok: () => { },
                close: () => { this.props.hidePopup(); }
            })
    }

    createNavbarRow = (label, icon) => {
        return (<>
            <div><FontAwesomeIcon icon={icon} /></div>
            <div style={{ paddingLeft: '.5em' }}><Translate id={label} /></div>
        </>);
    }

    toggleAccountMobileMenu = () => window.innerWidth <= 768 && this.props.toggleAccountMobileMenu();
}

export default withRouter(connect(
    state => state.userContext,
    dispatch => bindActionCreators({ ...userContextActions, ...layoutActions, ...lastSubjectActions, ...newsActions, ...popupActions }, dispatch)
)(UserSettings));